import React, { useMemo } from 'react';

import { ModalEntryPoint } from '../shared/modal-entry-point';

import { DIALOG_CONFIG } from './dialog-config';
import { entryPoint } from './entrypoint';

export function PremiumAddPaymentModal(): React.JSX.Element {
	const modalProps = useMemo(() => ({ width: 968, height: 576 }), []);

	return (
		<ModalEntryPoint entryPoint={entryPoint} modalProps={modalProps} dialogConfig={DIALOG_CONFIG} />
	);
}
